import { render, staticRenderFns } from "./pointSchoolIndex.vue?vue&type=template&id=668f9a97&scoped=true"
import script from "./pointSchoolIndex.vue?vue&type=script&lang=js"
export * from "./pointSchoolIndex.vue?vue&type=script&lang=js"
import style0 from "./pointSchoolIndex.vue?vue&type=style&index=0&id=668f9a97&prod&lang=scss&scoped=true"
import style1 from "./pointSchoolIndex.vue?vue&type=style&index=1&id=668f9a97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668f9a97",
  null
  
)

export default component.exports